import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DateFormatPipe } from 'src/app/pipes/dateFormat.pipe';
import { MatPaginator } from '@angular/material/paginator';
import { Location } from '@angular/common';
import { AccountUserService } from 'src/app/services/account-user.service';
@Component({
  selector: 'app-view-account-user',
  templateUrl: './view-account-user.component.html',
  styleUrls: ['./view-account-user.component.css']
})
export class ViewAccountUserComponent implements OnInit {
  userId: any;
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  account_user: any;
  pageIndex: any;
  constructor(private activatedRoute: ActivatedRoute,
    private accountuserService: AccountUserService,
    private route: ActivatedRoute,
    private router: Router,
    private _location: Location,
    private datepipe: DateFormatPipe) { }
  ngOnInit() {
    // this.pageIndex = this.route.snapshot.params['pageIndex'];
    this.activatedRoute.params.subscribe(params => {
      this.userId = params['id'];
      this.accountuserService.getUserById(this.userId)
        .subscribe(
          res => {
            this.account_user = res;
          }
        );
    });
  }
  // goBacktoList() {
  //   this.router.navigate(['../../list'], { queryParams: { pageNumber: this.pageIndex }, relativeTo: this.activatedRoute });
  // }
  goBacktoList() {
    this.router.navigate(['../../list'], { relativeTo: this.activatedRoute });
  }
  getCorrectDateAndTimeFormat(dateVal) {
    return this.datepipe.simpledateFormatWithTime(dateVal);
  }
}

